import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-stock-out-range',
  templateUrl: './stock-out-range.component.html',
  styleUrls: [],
  standalone: false
})
export class StockOutRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
